import { createStyles } from '@mantine/core';

type GamePickStylesProps = {
  isWinning: boolean;
  shouldMakePicks?: boolean;
};

const usePickGameStyles = createStyles(
  (theme, { isWinning, shouldMakePicks }: GamePickStylesProps) => {
    const getBGColor = () => {
      if (typeof isWinning !== 'boolean') return 'transparent';
      if (isWinning) return theme.colors.green[2];
      return theme.colors.red[1];
    };

    const getBorderColor = () => {
      if (shouldMakePicks) return theme.colors.red[4];
      if (typeof isWinning !== 'boolean') return theme.colors.gray[3];
      if (isWinning) return theme.colors.green[4];
      return theme.colors.red[4];
    };

    return {
      root: {
        padding: 0,
        background: 'transparent',
        '&:hover': {
          background: 'transparent',
        },
      },
      label: {
        overflow: 'visible',
        width: '100%',
      },
      imageContainer: {
        position: 'relative',
        border: '1px solid',
        overflow: 'hidden',
        background: getBGColor(),
        borderColor: getBorderColor(),
        padding: `${theme.spacing.xl / 8}px ${theme.spacing.md}px`,
        borderRadius: theme.spacing.xl / 8,
      },
      stack: {
        zIndex: 2,
        position: 'relative',
        width: '100%',
        borderColor: shouldMakePicks ? theme.colors.red[3] : 'transparent',
      },
      bestPickStar: {
        position: 'absolute',
        top: 2,
        right: 2,
        zIndex: 1,

        '& path': {
          fill: theme.colors.yellow[5],
        },
      },
    };
  }
);

export default usePickGameStyles;
